import React from 'react';
import { cn } from '@/lib/utils';

export const DataCard = ({ title, value, icon: Icon, description, trend, className }) => {
  return (
    <div
      data-testid="data-card"
      className={cn(
        'bg-white border border-slate-200 rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-200',
        className
      )}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-1">
            {title}
          </p>
          <p className="text-3xl font-bold text-slate-900 mb-1">{value}</p>
          {description && (
            <p className="text-sm text-slate-600">{description}</p>
          )}
          {trend && (
            <p className={cn(
              'text-xs font-medium mt-2',
              trend > 0 ? 'text-green-600' : 'text-red-600'
            )}>
              {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}%
            </p>
          )}
        </div>
        {Icon && (
          <div className="ml-4 p-3 bg-blue-50 rounded-lg">
            <Icon className="w-6 h-6 text-blue-600" />
          </div>
        )}
      </div>
    </div>
  );
};